import React, { useEffect, useRef, useState } from 'react'
import { Switch, Checkbox, PageHeader, Modal, Breadcrumb } from 'antd';
import { FileUploader } from "react-drag-drop-files";
import Editor from 'react-simple-wysiwyg';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { token } from '../../config';
import { apiClient } from '../../api';

const fileTypes = ["JPG", "PNG", "GIF"];

function CreateBanner() {
    const quillRef = useRef(null);
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const id = query.get('id')
    const [file, setFile] = useState(null);
    const today = new Date()
    const [input, setInput] = useState({ Detail: '', Status: 'active', startDate: `${String(today.getFullYear()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`, startTime: '12:00' })

    const handleChange = (file) => {
        if (file && file.type.startsWith('image/')) {
            // Create a temporary URL
            const imageUrl = URL.createObjectURL(file);
            const img = new Image();

            img.onload = () => {
                if (img.width === 612 && img.height === 384) {
                    // Size is correct
                    setFile(imageUrl);
                    setInput(prev => ({
                        ...prev,
                        file: file
                    }));
                } else {
                    // Not correct size
                    setFile(null);
                    Modal.error({
                        title: 'Fail',
                        content: `Image must be exactly 612 x 384 pixels. Selected image is ${img.width} x ${img.height}.`,
                        okText: 'OK',
                        icon: <i className="fa-solid fa-circle-xmark text-danger"></i>,
                    })
                }

                URL.revokeObjectURL(imageUrl);
            };

            img.onerror = () => {
                setFile(null);
                Modal.error({
                    title: 'Fail',
                    content: 'Failed to load the image.',
                    okText: 'OK',
                    icon: <i className="fa-solid fa-circle-xmark text-danger"></i>,
                })
                URL.revokeObjectURL(imageUrl);
            };

            img.src = imageUrl;
        } else {
            setFile(null);
        }
    };


    const inputChange = (event) => {
        const { name, value } = event.target
        setInput(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const inputDate = (event, name) => {
        const { value } = event.target
        setInput((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const inputCheck = (event, name) => {
        const { checked } = event.target
        setInput((prev) => ({
            ...prev,
            [name]: checked
        }))
    }

    const submitClick = (event) => {
        event.preventDefault()
        let formData = new FormData()
        if (id)
            formData.append('id', id)
        formData.append('Type', 'banner')
        // formData.append('Icon', 'warning')
        // formData.append('IconUrl', 'warning')
        formData.append('Thumbnail', input?.file || '')
        formData.append('icon_url', 'warning')
        formData.append('Topic', input?.Topic || '')
        formData.append('SubTopic', input?.SubTopic || '')
        formData.append('Detail', input?.Detail || '')
        formData.append('StartDatetime', `${input?.startDate || '2000-01-01'}T${input?.startTime || '00:00'}:00`)
        formData.append('EndDatetime', `${input?.endDate || '2000-01-01'}T${input?.endTime || '00:00'}:00`)
        formData.append('IsDefault', input?.IsDefault || 'false')
        formData.append('Status', input?.Status || 'active')
        apiClient.post(`api/Announcement/${id ? 'Update' : 'Create'}`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(result => {
            if (result.data === 'create announcement success' || result.data === 'updated successfully') {
                Modal.success({
                    title: 'Success',
                    content: '',
                    okText: 'OK',
                    icon: <i class="fa-solid fa-circle-check text-success"></i>,
                    onOk() {
                        window.location.href = '/home/bannerlists'
                    },
                })
            } else {
                Modal.error({
                    title: 'Fail',
                    content: '',
                    okText: 'OK',
                    icon: <i className="fa-solid fa-circle-xmark text-danger"></i>,
                })
            }
        })
    }

    const isCustomImage = (icon) =>
        icon === "Ants_LINEOA" ||
        icon === "Ants_LON" ||
        icon === "Ants_MMS" ||
        icon === "Ants_SMS";

    useEffect(() => {
        if (id) {
            apiClient.post('api/Announcement/ListByID', {
                uid: id
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8'
                }
            }).then(result => {
                const startDate = result.data.StartDatetime.split(' ')[0]
                const endDate = result.data.EndDatetime.split(' ')[0]
                const startTime = result.data.StartDatetime?.split(' ')[1]?.split(':')?.slice(0, 2)?.join(':')
                const endTime = result.data.EndDatetime.split(' ')[1]?.split(':')?.slice(0, 2)?.join(':')

                setInput({
                    ...result.data,
                    startDate: startDate,
                    startTime: startTime,
                    endDate: endDate,
                    endTime: endTime
                })
                setFile(isCustomImage(result.data.IconUrl) ? `/img/vendors/news/${result.data.IconUrl}.jpg` : `api/Announcement/Image/${result.data.IconUrl}`)
            })
        }
    }, [])

    return (
        <div className="animated fadeIn">
            <PageHeader
                className="pageHeaderCustom"
                title={
                    <div className="headerTitle">
                        <div>
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <a href="/home/bannerlists">News</a>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item style={{ fontSize: 29, fontWeight: 100 }}>
                                    {id ? 'Edit' : 'Create'} News
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </div>
                }
            ></PageHeader>
            <div className='containner ml-5 mr-5 mt-3'>
                <form onSubmit={submitClick}>
                    <div className='card-form mt-3'>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <label className='text-label font-weight-bold word-break'>Preview</label>
                                <div className='border-preview w-100 word-break p-3 d-flex justify-content-center flex-column'>
                                    <div className='w-100 d-flex justify-content-center'>
                                        <img className='image-center max-w-100 crop' src={file} />
                                    </div>
                                    <h5 className=''>{input.Topic}</h5>
                                    <b>{input.SubTopic}</b>
                                    <p
                                        dangerouslySetInnerHTML={{ __html: input?.Detail || '' }}
                                    />
                                </div>
                            </div>
                            <div className='col-lg-8'>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <div className="form-group">
                                            <div className='text-label font-weight-bold'>Topic<span className='pl-1 text-danger'>*</span></div>
                                            <input id="Topic" name='Topic' type="text" className="form-control" placeholder="Topic" onChange={inputChange} value={input.Topic} required />
                                        </div>
                                    </div>
                                    <div className='col-lg-12'>
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <div className="form-group">
                                                    <div className='text-label font-weight-bold'>Sub Topic</div>
                                                    <input name='SubTopic' type="text" className="form-control" placeholder="Sub Topic" onChange={inputChange} value={input.SubTopic} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-12'>
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <div className="form-group">
                                                    <div className='text-label font-weight-bold'>Detail</div>
                                                    <Editor
                                                        value={input?.Detail || ''}
                                                        name='Detail'
                                                        onChange={(event) => setInput(prev => ({ ...prev, Detail: event.target.value }))}
                                                        required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="text-label font-weight-bold mb-2">Thumbnails Image<span className='pl-1 text-danger'>*</span></div>
                                        <div className="w-100 d-block">
                                            <div className="d-flex justify-content-center border-thumbnail w-100">
                                                {file && <button className='cancle-btn' onClick={() => setFile(null)}>X</button>}
                                                <FileUploader
                                                    handleChange={handleChange}
                                                    name="file"
                                                    types={fileTypes}
                                                    label="Drop your image here, or Browse"
                                                    children={
                                                        <>
                                                            <div
                                                                className="w-100 h-100 d-flex justify-content-center align-items-center"
                                                            >
                                                                <div>
                                                                    <img className={`w-100 ${file && 'crop'}`} src={file ? file : '/img/vendors/icon/upload.svg'} />
                                                                    {!file && <div>Drop your image here, or Browse</div>}
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                    required={id ? false : true}
                                                />
                                            </div>
                                        </div>
                                        <label>recommended dimensions: 612x384 pixels</label>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='form-group d-flex align-items-center'>
                                            <Switch checked={input?.Status === 'inactive' ? false : true} onChange={(event) => setInput(prev => ({ ...prev, Status: event == true ? 'active' : 'inactive' }))} />
                                            <span className='ml-1 mb-0 text-label font-weight-bold'>{input?.Status === 'active' ? 'Active' : 'Inactive'}</span>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <div className='text-label font-weight-bold d-flex align-items-center'><Checkbox className='my-auto mr-1' onChange={(event) => inputCheck(event, 'IsDefault')} checked={input.IsDefault}></Checkbox> Always Display</div>
                                        </div>
                                    </div>
                                    {!input.IsDefault &&
                                        <>
                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <div className='text-label font-weight-bold'>Start Date<span className='pl-1 text-danger'>*</span></div>
                                                    <input type="date" className="form-control" id="date" name="date" onChange={(event) => inputDate(event, 'startDate')} value={input.startDate} required />
                                                </div>
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <div className='text-label font-weight-bold'>Start Time<span className='pl-1 text-danger'>*</span></div>
                                                    <input type="time" className="form-control" id="time" name="time" onChange={(event) => inputDate(event, 'startTime')} value={input.startTime} required />
                                                </div>
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <div className='text-label font-weight-bold'>End Date<span className='pl-1 text-danger'>*</span></div>
                                                    <input type="date" className="form-control" id="date" name="date" onChange={(event) => inputDate(event, 'endDate')} value={input.endDate} required />
                                                </div>
                                            </div>
                                            <div className='col-lg-6'>
                                                <div className='form-group'>
                                                    <div className='text-label font-weight-bold'>End Time<span className='pl-1 text-danger'>*</span></div>
                                                    <input type="time" className="form-control" id="time" name="time" onChange={(event) => inputDate(event, 'endTime')} value={input.endTime} required />
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className='col-md-12'>
                                        <Link to="/home/bannerlists"><button className='ant-btn align-self-center align-middle' style={{ borderColor: '#19164F', color: '#19164F', marginRight: '15px', fontWeight: 'bold', fontSize: '20px', borderRadius: '10px', height: '40px' }} type='submit'>Cancel</button></Link>
                                        <button className='ant-btn align-self-center align-middle' style={{ backgroundColor: '#19164F', color: 'rgb(255, 255, 255)', marginRight: '15px', fontSize: '20px', borderRadius: '10px', height: '40px' }} type='submit'>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CreateBanner